export interface SearchBibliographyIsbnRequest {
  isbn: string
}

export function SearchBibliographyIsbnRequestToJSON(
  value: SearchBibliographyIsbnRequest
): any {
  return {
    isbn: value.isbn !== '' ? value.isbn : undefined
  }
}
